
import get from 'lodash/get';
import debounce from 'lodash/debounce';
import VLazyImage from 'v-lazy-image';
import { PLACEHOLDER_IMG } from '@/constants/global';

export default {
  components: {
    VLazyImage,
  },
  props: {
    media: {
      type: Array,
      default: () => [],
    },
    header: {
      type: String,
      default: '',
    },
    includeShowMore: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      placeholderImg: PLACEHOLDER_IMG,
      toggleEmbed: false,
    };
  },
  mounted() {
    this.handleDebouncedScroll = debounce(this.onScroll, 100);
    window.addEventListener('scroll', this.handleDebouncedScroll);

    const clickableStoryImages = document.querySelectorAll('.open-carousel-modal-on-click');
    clickableStoryImages.forEach((imgElement) => imgElement.addEventListener('click', this.openCarouselModal));
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleDebouncedScroll);

    const clickableStoryImages = document.querySelectorAll('.open-carousel-modal-on-click');
    clickableStoryImages.forEach((imgElement) => imgElement.removeEventListener('click', this.openCarouselModal));
  },
  methods: {
    // On scroll into view, load embed video
    onScroll() {
      if (this.toggleEmbed) return;

      const el = get(this, ['$refs', 'overviewSection']);

      if (el) {
        const rect = el.getBoundingClientRect();
        const isVisible = (
          (rect.top >= 0 && rect.top <= window.innerHeight)
          || (rect.bottom >= 0 && rect.bottom <= window.innerHeight)
        );

        if (isVisible) this.toggleEmbed = true;
      }
    },
    showMore() {
      this.$emit('show-more');
    },
    openCarouselModal(event) {
      if (event.currentTarget?.dataset?.storyImageId) {
        this.$store.dispatch(
          'carouselModal/openModalToImage',
          { targetImageSlug: event.currentTarget.dataset.storyImageId },
        );
      }
    },
  },
};
